export default "__VITE_ASSET__BATMt0bL__"